<template>
  <div class="fan fan-component f-plugin-indoormap">
    <!-- 顶部查询条件 -->
    <div class="top-bar" v-if="searchColumns.length > 0">
      <template v-for="col in searchColumns" :key="col.dataIndex">
        <a-select
          v-if="col.form === 'select'"
          v-model="searchValues[col.dataIndex]"
          :placeholder="'选择' + col.title"
          style="width:180px;"
          allow-clear
          @change="onSearchChange"
        >
          <a-option v-for="(opt, idx) in getStoreOptions(col.dataIndex)" :key="idx" :value="opt.value" :label="opt.label" />
        </a-select>
        <a-input
          v-else
          v-model="searchValues[col.dataIndex]"
          :placeholder="'输入' + col.title"
          style="width:180px;"
          allow-clear
          @input="onSearchInput"
        />
      </template>
      <span class="tip">点击地图标记查看详情</span>
    </div>

    <a-spin :loading="loading">
      <div class="map-wrap" v-if="bgImage">
        <div class="zoom-controls">
          <a-button size="small" @click="zoomIn" :disabled="scale >= 3"><icon-zoom-in /></a-button>
          <span class="zoom-label">{{ Math.round(scale * 100) }}%</span>
          <a-button size="small" @click="zoomOut" :disabled="scale <= 0.3"><icon-zoom-out /></a-button>
          <a-button size="small" @click="zoomReset"><icon-refresh /></a-button>
        </div>
        <div class="map-area" :style="{ transform: `scale(${scale})`, transformOrigin: '0 0' }">
          <IndoorMarker
            width="100%"
            height="auto"
            :value="markerBlocks"
            :backgroundImage="{ url: bgImage, width: '100%', height: 'auto' }"
            :readonly="true"
            @blockClick="onBlockClick" />
        </div>
      </div>
      <div v-else class="empty-tip">暂无平面图</div>
    </a-spin>

    <a-modal v-model:visible="detailVisible" :title="detailDevice.name || '设备详情'" :footer="false" :width="600" unmount-on-close>
      <f-detail v-if="detailVisible"
                :superApi="superApi"
                :superData="detailDevice"
                @emitCloseDrawer="detailVisible = false" />
    </a-modal>
  </div>
</template>

<script>
import IndoorMarker from '@/companents/parts/IndoorMarker.vue'

export default {
  name: 'FPluginIndoorMap',
  components: { IndoorMarker },
  props: {
    superTitle: { type: String, default: '' },
    superApi: { type: String, default: '' },
    superColumns: { type: Array, default: () => [] },
    superIdDevicetype: { type: [Number, String], default: 12 },
    markerIcon: { type: String, default: '' },
    typeApi: { type: String, default: 'devicetype' },
    typeImageField: { type: String, default: 'image' },
    filterField: { type: String, default: 'id_devicetype' },
  },
  data() {
    return {
      loading: false,
      scale: 1,
      bgImage: '',
      devices: [],
      detailVisible: false,
      detailDevice: {},
      searchValues: {}
    }
  },
  computed: {
    markerBlocks() {
      return this.devices.map(d => ({
        id: d.id,
        type: d.id_devicetype,
        name: d.name,
        icon: this.markerIcon || undefined,
        x: d.points?.x != null ? d.points.x : 50,
        y: d.points?.y != null ? d.points.y : 50
      }))
    },
    // 需要生成查询条件的列
    searchColumns() {
      if (!this.superColumns || !this.superColumns.length) return []
      return this.superColumns.filter(col => col.search && col.dataIndex)
    }
  },
  async mounted() {
    await this.loadDeviceType()
    await this.loadDevices()
    this.setupStore()
  },
  methods: {
    // 从 store 获取选项（loadCallback 加载后存入 store.state.page.options）
    getStoreOptions(field) {
      const storeOpts = this.$store?.state?.page?.options
      return (storeOpts && storeOpts[field]) || []
    },

    zoomIn() { this.scale = Math.min(3, this.scale + 0.25) },
    zoomOut() { this.scale = Math.max(0.3, this.scale - 0.25) },
    zoomReset() { this.scale = 1 },

    setupStore() {
      const columns = {}
      this.superColumns.forEach(c => {
        if (c.dataIndex) {
          columns[c.dataIndex] = { name: c.title, type: c.dataIndex, form: c.form }
        }
      })
      this.$store.state.page.columns = columns
      this.$store.state.page.tableColumns = this.superColumns
      this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
    },

    // 查询条件变化
    onSearchChange() {
      this.loadDevices()
    },

    onSearchInput() {
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.loadDevices()
      }, 500)
    },

    buildQueryParams() {
      const params = {}
      this.searchColumns.forEach(col => {
        const field = col.dataIndex
        const val = this.searchValues[field]
        if (val !== undefined && val !== '' && val !== null) {
          params[field] = val
        }
      })
      return params
    },

    async loadDeviceType() {
      try {
        const res = await this.$fan.api.get(this.typeApi, { page: 1, limit: 999, _tree: 'true' })
        if (res && res.status === 0) {
          const data = res.data?.data || res.data || []
          const find = (arr) => {
            for (const item of arr) {
              if (item.id == this.superIdDevicetype) return item
              if (item.children) { const f = find(item.children); if (f) return f }
            }
            return null
          }
          const dt = find(data)
          if (dt) this.bgImage = dt[this.typeImageField] || ''
        }
      } catch {}
    },

    async loadDevices() {
      this.loading = true
      try {
        const query = { [this.filterField]: this.superIdDevicetype, page: 1, limit: 999, ...this.buildQueryParams() }
        const res = await this.$fan.api.get(this.superApi, query)
        if (res && res.status === 0) {
          const list = res.data?.data || res.data || []
          this.devices = list.map(d => {
            let pt = d.points
            if (typeof pt === 'string') { try { pt = JSON.parse(pt) } catch { pt = {} } }
            return { ...d, points: { x: pt?.x != null ? pt.x : 50, y: pt?.y != null ? pt.y : 50 } }
          })
        }
      } catch {} finally { this.loading = false }
    },

    getFieldValue(obj, path) {
      if (!obj || !path) return undefined
      const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.')
      let val = obj
      for (const k of keys) { if (val == null) return undefined; val = val[k] }
      return val
    },

    async onBlockClick(block) {
      const dev = this.devices.find(d => d.id == block.id)
      if (!dev) return
      await this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      const cols = this.$store.state.page.columns || {}
      const keyinfo = this.$store.state.page?.keyinfo || {}
      const flat = { ...dev }
      this.superColumns.forEach(col => {
        if (!col.dataIndex) return
        if (col.dataIndex.includes('[') || col.dataIndex.includes('.')) {
          let val = this.getFieldValue(dev, col.dataIndex)
          if (['select', 'radio', 'cascader'].includes(col.form)) {
            const optMap = keyinfo[col.dataIndex]
            if (optMap && val != null) {
              const name = optMap[val]?.name || optMap[String(val)]?.name || val
              if (name) { val = name; if (cols[col.dataIndex]) cols[col.dataIndex].form = 'input' }
            }
          }
          if (col.unit && val != null && val !== '-') val = val + ' ' + col.unit
          flat[col.dataIndex] = val
        }
      })
      this.detailDevice = flat
      this.detailVisible = true
    }
  }
}
</script>

<style scoped lang="less">
.f-plugin-indoormap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.top-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-shrink: 0;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;

  .tip {
    color: #86909c;
    font-size: 13px;
    margin-left: auto;
  }
}

.map-wrap {
  position: relative;
  flex: 1;
  overflow: auto;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
}

.zoom-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.9);
  padding: 6px 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.zoom-label {
  font-size: 12px;
  color: #4e5969;
  min-width: 36px;
  text-align: center;
}

.map-area {
  transform-origin: 0 0;
  transition: transform 0.15s;
}

.empty-tip {
  text-align: center;
  color: #c9cdd4;
  padding: 200px 0;
  font-size: 16px;
}
</style>
